module.exports = __webpack_public_path__ + "static/img/banner_5.d578da3.png";


//////////////////
// WEBPACK FOOTER
// ./static/otherpage/banner_5.png
// module id = aL/a
// module chunks = 1